import { render } from "./AccessDeniedPage.vue?vue&type=template&id=7a400175"
import script from "./AccessDeniedPage.vue?vue&type=script&lang=js"
export * from "./AccessDeniedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__